// extracted by mini-css-extract-plugin
export var callCard = "_ri-0";
export var callMessageButton = "_ri-1";
export var helpIcon = "_ri-3";
export var helpIconContainer = "_ri-4";
export var verticalDivider = "_ri-2";